import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  ConselhoDetailsState,
  ConselhoDetailsAction,
  ConselhoDetailsReducer,
} from './conselho-details-reducer';

const initialState: ConselhoDetailsState = {
  conselhoDetails: null,
  loading: false,
  error: null,
};

const ConselhoDetailsStateContext = createContext<ConselhoDetailsState | undefined>(undefined);
const ConselhoDetailsDispatchContext = createContext<React.Dispatch<ConselhoDetailsAction> | undefined>(undefined);

interface ConselhoDetailsProviderProps {
  children: ReactNode;
}

export const ConselhoDetailsProvider: React.FC<ConselhoDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(ConselhoDetailsReducer, initialState);

  return (
    <ConselhoDetailsStateContext.Provider value={state}>
      <ConselhoDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </ConselhoDetailsDispatchContext.Provider>
    </ConselhoDetailsStateContext.Provider>
  );
};

export const useConselhoDetailsState = (): ConselhoDetailsState => {
  const context = useContext(ConselhoDetailsStateContext);
  if (context === undefined) {
    throw new Error('useConselhoDetailsState must be used within a ConselhoDetailsProvider');
  }
  return context;
};

export const useConselhoDetailsDispatch = (): React.Dispatch<ConselhoDetailsAction> => {
  const context = useContext(ConselhoDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useConselhoDetailsDispatch must be used within a ConselhoDetailsProvider');
  }
  return context;
};
